import { createReducer, on } from '@ngrx/store';
import { CHANGE_ACCOUNT, CHANGE_ACCOUNT_SUCCESS, CORE_CLEAR_STATE, NOTIFICATION_CLEAR, NOTIFICATION_SHOW } from '@store/actions';
import { NotificationMessage } from '@core/interfaces';

export interface CoreState {
  notification: NotificationMessage | null;
  changeAccount: boolean
}

export const initialState: CoreState = {
  notification: null,
  changeAccount: false,
};

export const coreReducer = createReducer(
  initialState,
  on(NOTIFICATION_SHOW, (state, { notification }) => ({ ...state, notification })),
  on(NOTIFICATION_CLEAR, (state) => ({ ...state, notification: initialState.notification })),
  //TODO
  // on(CHANGE_ACCOUNT, (state) => ({ ...state, changeAccount: !state.changeAccount })),
  on(CHANGE_ACCOUNT, (state) => ({ ...state, changeAccount: true })),
  on(CHANGE_ACCOUNT_SUCCESS, (state) => ({ ...state, changeAccount: false })),
  on(CORE_CLEAR_STATE, () => initialState),
);
